import dynamic from "next/dynamic";
import { INLINES, BLOCKS, MARKS } from "@/components/content/rich-text";
import Link from "next/link";
import { ComponentMap } from "./index";
import { documentToReactComponents } from "@/components/content/rich-text";

const Embed = dynamic(() => import("@/components/embeds"), { ssr: false });
const Image = dynamic(() => import("@/components/image"));

const Bold = (text) => <strong className="font-normal">{text}</strong>;

const L = (link, children = null) => {
  const label =
    children ?? link.content?.map((x) => x.value).filter(Boolean).join(" ");

  return (
    <a
      href={link.data.uri}
      rel="noopener noreferrer"
      className="font-medium text-brand-600 hover:text-brand-500"
    >
      {label}
    </a>
  );
};

const A = (node, next) => {
  const { fields } = node.data.target;
  return fields.url ? (
    <Link href={fields.url ?? ""} className="cursor-pointer">
      <figure>
        <Image
          id="JKHVFJ"
          alt=""
          className="w-full rounded-lg"
          fields={node.data.target}
          width={fields.file.details.image.width}
          height={fields.file.details.image.height}
        />
        {fields.title && <figcaption>{fields.title}</figcaption>}
      </figure>
    </Link>
  ) : (
    <figure>
      <Image
        id="JKHVFJ"
        alt=""
        className="w-full rounded-lg"
        fields={node.data.target}
        width={fields.file.details.image.width}
        height={fields.file.details.image.height}
      />
      {fields.title && <figcaption>{fields.title}</figcaption>}
    </figure>
  );
  // return (
  //   <Link href={fields.url ?? ""} className="cursor-pointer">
  //     <figure>
  //       <Image
  //         id="JKHVFJ"
  //         alt=""
  //         className="w-full rounded-lg"
  //         fields={node.data.target}
  //         width={fields.file.details.image.width}
  //         height={fields.file.details.image.height}
  //       />
  //       {fields.title && <figcaption>{fields.title}</figcaption>}
  //     </figure>
  //   </Link>
  // );
};

const E = (node, next) => {
  const { sys, fields } = node.data.target;
  if (ComponentMap[sys.contentType.sys.id]) {
    const Cmp = ComponentMap[sys.contentType.sys.id];
    return (
      <Cmp
        key={`${node.nodeType}-${sys.contentType.sys.id}`}
        fields={fields}
        sys={sys}
        includes={{}}
      />
    );
  }
  return null;
};

const LI = (node, children) => <li>{children}</li>;

const Iframe = (link) => {
  return (
    <span className="block aspect-w-16 aspect-h-9 mt-16 rounded-lg overflow-hidden">
      <iframe
        className="w-full"
        width="100%"
        height="100%"
        src={link.data.uri}
        title="YouTube video player"
        frameBorder="0"
        loading="lazy"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </span>
  );
};

const C = (node) => {
  const [type, url] = node.split("|");
  return <Embed type={type} url={url} />;
};

export const richContentOptions = {
    renderMark: {
      [MARKS.BOLD]: Bold,
      [MARKS.CODE]: C,
    },
    renderNode: {
      [INLINES.HYPERLINK]: (link, children) => {
        return link.data.uri.includes("youtube") ? (
          <Iframe {...link} />
        ) : (
          L(link, children)
        );
      },
      [BLOCKS.EMBEDDED_ASSET]: A,
      [INLINES.EMBEDDED_ENTRY]: E,
      [BLOCKS.LIST_ITEM]: LI,
    },
  };
